module.exports = __webpack_public_path__ + "static/img/Front Eureka_9.35561dc1.png";